import {
  Divider,
  FlatList,
  Flex,
  Hidden,
  Stack,
  Text,
  VStack,
} from 'native-base';
import Button from 'ui/components/Button';
import Icon from 'ui/components/Icon';
import { ILLUSTRATIONS_NAME } from 'ui/components/Illustration';
import Loading from 'ui/components/Loading';

import { ListEmptyState } from '~/components/EmptyState/ListEmptyState';
import { Scaffold } from '~/components/Scaffold';
import { EcosystemDownloadFilesHeader } from '~/pages/Authenticated/EcosystemDownloadFiles/components/EcosystemDownloadFilesHeader';
import { useEcosystemDownloadFilesController } from '~/pages/Authenticated/EcosystemDownloadFiles/controller';

export const EcosystemDownloadFiles = () => {
  const { downloadableFiles, isLoading, handleDownloadFile } =
    useEcosystemDownloadFilesController();

  return (
    <Scaffold>
      <Stack
        bg={'singletons.white'}
        px={4}
        py={{ base: 3, lg: 6 }}
        pb={0}
        flex={1}
        rounded={8}
        roundedTop={0}
        flexGrow={1}
      >
        <EcosystemDownloadFilesHeader />
        {isLoading ? <Loading containerHeight="80vh" /> : null}

        <FlatList
          data={downloadableFiles}
          ListEmptyComponent={
            <VStack
              width="100%"
              height="80vh"
              alignItems="center"
              justifyContent="center"
            >
              <Stack>
                <ListEmptyState
                  illustrationName={ILLUSTRATIONS_NAME.EMPTY_NOT_FOUND}
                  text="No files found for this ecosystem."
                />
              </Stack>
            </VStack>
          }
          renderItem={({ item }) => {
            return (
              <Flex
                flexDirection={{
                  base: 'column',
                  lg: 'row',
                }}
                justifyContent={{
                  base: 'center',
                  lg: 'space-between',
                }}
                alignItems={{ base: 'normal', lg: 'center' }}
              >
                <VStack space={1} py={4}>
                  <Text fontWeight={500} color={'gray.600'} fontSize={'md'}>
                    {item.name}
                  </Text>
                  <Text fontSize={'xs'} color={'gray.600'}>
                    {item.description}
                  </Text>
                </VStack>

                <Hidden till="lg">
                  <Button
                    px={0}
                    variant={'ghost'}
                    maxW={'103px'}
                    minW={'103px'}
                    _text={{
                      fontWeight: 500,
                      fontSize: 'xs',
                    }}
                    leftIcon={
                      <Icon icon="download" size={16} color={'black'} />
                    }
                    onPress={() => handleDownloadFile(item.link, item.name)}
                  >
                    Download
                  </Button>
                </Hidden>

                <Hidden from="lg">
                  <Button
                    px={0}
                    variant={'solid'}
                    maxW={'100%'}
                    minW={'100%'}
                    _text={{
                      fontWeight: 500,
                      fontSize: 'xs',
                    }}
                    leftIcon={
                      <Icon icon="download" size={16} color={'white'} />
                    }
                    onPress={() => handleDownloadFile(item.link, item.name)}
                  >
                    Download
                  </Button>
                </Hidden>
              </Flex>
            );
          }}
          ItemSeparatorComponent={() => <Divider mt={{ base: 4, lg: 0 }} />}
        />
      </Stack>
    </Scaffold>
  );
};
